document.addEventListener('DOMContentLoaded', () => {
  const productTags = window.productTags || [];
  const minQty = 6;

  // Only apply to products tagged "border_color"
  if (!productTags.includes('border_color')) return;

  // Wait until quantity input is available
  const waitForQtyInput = setInterval(() => {
    const qtyInput = document.querySelector('quantity-input input[name="quantity"]') ||
                     document.querySelector('input[name="quantity"]');

    if (qtyInput) {
      clearInterval(waitForQtyInput);

      // Set initial min value
      qtyInput.min = minQty;
      if (parseInt(qtyInput.value) < minQty) {
        qtyInput.value = minQty;
      }

      // Prevent typing a smaller number
      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value);
        if (val < minQty) {
          alert(`Minimum order quantity for this product is ${minQty}.`);
          qtyInput.value = minQty;
        }
      });

      // Enforce rule when adding to cart
      const productForm = document.querySelector('product-form form');
      if (productForm) {
        productForm.addEventListener('submit', (e) => {
          const qty = parseInt(qtyInput.value);
          if (qty < minQty) {
            e.preventDefault();
            alert(`You must order at least ${minQty} of this product.`);
            qtyInput.value = minQty;
          }
        });
      }
    }
  }, 300); // Check every 300ms in case Shopify loads it dynamically
});
